module.exports = __webpack_public_path__ + "static/img/tu2@1x.20952fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/tu2@1x.png
// module id = 7lb/
// module chunks = 2